export const localStorageHelper = {
  load(key: string) {
    const value = localStorage.getItem(key);
    return value == null ? undefined : value;
  },
  store(key: string, value: any) {
    localStorage.setItem(key, value);
  },
  modify(key: string, value: any) {
    this.store(key, value);
  },
  remove: (key: string) => {
    localStorage.removeItem(key);
  },
  clearLocalStorage: () => {
    localStorage.clear();
  },
};
